import { render } from "./QuestionGdprScreen.vue?vue&type=template&id=dd18d5f0&scoped=true&lang=html"
import script from "./QuestionGdprScreen.vue?vue&type=script&lang=js"
export * from "./QuestionGdprScreen.vue?vue&type=script&lang=js"

import "./QuestionGdprScreen.vue?vue&type=style&index=0&id=dd18d5f0&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/bcfcareer25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd18d5f0"]])

export default __exports__